import { render, staticRenderFns } from "./HeadquarterAndBranches.vue?vue&type=template&id=3b2ee4e3&scoped=true"
import script from "./HeadquarterAndBranches.vue?vue&type=script&lang=js"
export * from "./HeadquarterAndBranches.vue?vue&type=script&lang=js"
import style0 from "./HeadquarterAndBranches.vue?vue&type=style&index=0&id=3b2ee4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ee4e3",
  null
  
)

export default component.exports